if ($(".id-2022").length) {
  renderRecentlyViewed(true);
}

if ($(".id--8").length) {
  $("#content .content-inner").append($("#footer .registrationBanner").clone());
}
